module.exports = __webpack_public_path__ + "img/SSP-Part1.c93c2340.png";